import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { Form, FormGroup, Row, Col } from "react-bootstrap";
import Button from "../../../../components/common/button/Button";
import Input from "../../../../components/common/input/Input";
import Select2 from "../../../../components/common/select/Select2";
import Radio from "../../../../components/common/radio/Radio";
import Textarea from "../../../../components/common/textarea/Textarea";
import AutoCompleteCity from "../../completeProfile/components/AutoCompleteCity";
import { required, maxLength } from "../../../../utils/forms/validators";
import ScrollToTopOnMount from "../../../../utils/scroll/ScrollToTopOnMount";
import styles from "./SummaryAdmin.scss";

import { getUserData, getUserDataById } from "../../../../actions/user.actions";

const maxLengthValidation = (max, msg) => maxLength(max, msg);

const maxLengthSummary = maxLengthValidation(
  1500,
  "Summary must be between 150 and 1500 characters."
);

const industry = maxLengthValidation(
  30,
  "Industry must be less than or equal to 30 characters."
);
const INDUSTRY_OTHER = 38;

class SummaryAdmin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      industry: {
        primary: null,
        secondary: null
      }
    };

    this.handleSelect = this.handleSelect.bind(this);
  }

  componentDidMount() {
    const { memberId } = this.props;

    if (memberId) {
      this.props.getUserDataById(memberId);
    } else {
      this.props.getUserData();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.user !== nextProps.user) {
      const industry = {
        primary: _.get(nextProps, "user.profile.primary_industry_id"),
        secondary: _.get(nextProps, "user.profile.secondary_industry_id")
      };

      this.setState({ industry: industry });
    }
  }

  handleSelect(value, name) {
    if (value !== INDUSTRY_OTHER) {
      this.props.change(`${name}_industry_other`, null);
    }

    const industry = { ...this.state.industry, [name]: value };
    this.setState({ industry: industry });
  }

  render() {
    const { submitting, valid } = this.props;

    return (
      <section>
        <ScrollToTopOnMount />
        <section className={styles.summary}>
          <div className={styles.content}>
            <h2 className={styles.title}>Summary</h2>

            <Form onSubmit={this.props.handleSubmit}>
              <div className={styles.form}>
                <FormGroup>
                  <AutoCompleteCity
                    id={this.props.user.id}
                    col={8}
                    focus={this.props.defaultLocation ? true : false}
                    icon="map-marker"
                    showPasswordIcon={true}
                    cities={this.props.cities}
                    isLoading={this.props.isLoading}
                    onSearchCities={this.props.searchCitiesAutocomplete}
                    selectedValue={this.props.defaultLocation}
                    commuteCities={this.props.commuteCities}
                    focusOut={(query, selected) => {
                      if (!selected) {
                        this.props.change("city", null);
                      }
                    }}
                  />

                  <div className={styles.dividerNoPadding} />

                  <div className={styles.sectionSubtitle}>Level</div>

                  <Row className={styles.item}>
                    <Col md={6} xs={12} className={styles.itemPadding}>
                      <Field
                        name="level_id"
                        type="select"
                        placeholder="Select Level"
                        component={Select2}
                        options={this.props.levels}
                      />
                    </Col>
                  </Row>

                  <div className={styles.dividerNoPadding} />

                  <div className={styles.sectionTitle}>Industry</div>

                  <div className={styles.sectionDescription}>
                    Select the industry or industries where you have had the
                    bulk of your work experience.
                  </div>

                  <div className={styles.sectionSubtitle}>Primary Industry</div>

                  <Row className={styles.item}>
                    <Col md={6} xs={12} className={styles.itemPadding}>
                      <Field
                        name="primary_industry_id"
                        type="select"
                        placeholder="Select Primary Industry"
                        component={Select2}
                        options={this.props.industries}
                        onSelectChange={e => this.handleSelect(e, "primary")}
                      />
                    </Col>
                    {this.state.industry.primary === INDUSTRY_OTHER && (
                      <Col md={6} xs={12} className={styles.itemPadding}>
                        <Field
                          name="primary_industry_other"
                          type="text"
                          placeholder="Industry"
                          component={Input}
                          validate={[required, industry]}
                        />
                      </Col>
                    )}
                  </Row>

                  <div className={styles.sectionSubtitle}>
                    Secondary Industry (Optional)
                  </div>

                  <Row className={styles.item}>
                    <Col md={6} xs={12} className={styles.itemPadding}>
                      <Field
                        name="secondary_industry_id"
                        type="select"
                        placeholder="Select Secondary Industry"
                        component={Select2}
                        options={this.props.industries}
                        onSelectChange={e => this.handleSelect(e, "secondary")}
                      />
                    </Col>
                    {this.state.industry.secondary === INDUSTRY_OTHER && (
                      <Col md={6} xs={12} className={styles.itemPadding}>
                        <Field
                          name="secondary_industry_other"
                          type="text"
                          placeholder="Industry"
                          component={Input}
                          validate={[required, industry]}
                        />
                      </Col>
                    )}
                  </Row>

                  <div className={styles.dividerNoPadding} />

                  <div className={styles.sectionSubtitle}>
                    Would you consider a full-time, on-staff job?
                  </div>

                  <fieldset className={styles.checkboxContainer}>
                    <Row>
                      <Col md={7} xs={7}>
                        <Field
                          name="full_time_job"
                          component={Radio}
                          type="radio"
                          value={true}
                          text="Yes"
                          parse={val => val === "true"}
                          handleChange={e => (e.target.checked = true)}
                          checked={
                            this.props.initialValues &&
                            this.props.initialValues.full_time_job
                          }
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col md={7} xs={7}>
                        <Field
                          name="full_time_job"
                          component={Radio}
                          type="radio"
                          value={false}
                          text="No"
                          parse={val => val === "true"}
                          handleChange={e => (e.target.checked = true)}
                          checked={
                            this.props.initialValues &&
                            this.props.initialValues.full_time_job
                          }
                        />
                      </Col>
                    </Row>
                  </fieldset>

                  <div className={styles.divider} />

                  <div className={styles.sectionTitle}>
                    Professional Summary
                  </div>

                  <div className={styles.sectionDescription}>
                    Your summary will be visible to hiring managers once you
                    express interest in their project. Tell them in a few words
                    about your professional life and career accomplishments.
                  </div>

                  <Field
                    name="professional_summary"
                    type="textarea"
                    placeholder=""
                    component={Textarea}
                    //help='1500 characters.'
                    maxlength={1500}
                    validate={[required, maxLengthSummary]}
                  />
                </FormGroup>

                <div className={styles.dividerDouble} />

                <div className={styles.CTAContainer}>
                  <Button
                    isPrimary
                    type="submit"
                    size={"large"}
                    label="Save Changes"
                    isDisabled={!valid || submitting || this.props.saving}
                    isLoading={this.props.saving}
                    loadingText="Saving..."
                  />
                </div>
              </div>
            </Form>
          </div>
        </section>
      </section>
    );
  }
}

SummaryAdmin = reduxForm({
  form: "summary",
  enableReinitialize: true,
  touchOnChange: true
})(SummaryAdmin);

const selector = formValueSelector("summary");
SummaryAdmin = connect(
  state => {
    const defaultLocation = selector(state, "city_obj");
    return {
      defaultLocation,
      user: state.user.data,
      initialValues: state.user.data,
      saving: state.user.loading
    };
  },
  dispatch => {
    return {
      getUserData: () => dispatch(getUserData()),
      getUserDataById: id => dispatch(getUserDataById(id))
    };
  }
)(SummaryAdmin);

export default SummaryAdmin;



// WEBPACK FOOTER //
// ./src/routes/candidate/profile/components/SummaryAdmin.js